import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../config'

class CompanyService extends Service {
  path = 'empresaavaliadora'

  async get(params: any) {
    const httpResponse = await this.httpClient.get(this.path, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async download(params: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/excel`, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async post(params: any) {
    const httpResponse = await this.httpClient.post(this.path, params)
    return httpResponse
  }

  async delete(params: any) {
    const httpResponse = await this.httpClient.delete(
      this.path + `?empresaAvaliadoraId=${params.id}`,
      { data: { motivo: params.motivation } }
    )
    return httpResponse
  }

  async put(id: string, params: any) {
    const httpResponse = await this.httpClient.put(
      this.path + `?empresaId=${id}`,
      params
    )
    return httpResponse
  }

  async active(params: any) {
    const httpResponse = await this.httpClient.put(
      this.path + `/ativar?empresaAvaliadoraId=${params.id}`,
      { motivo: params.motivation }
    )
    return httpResponse
  }

  async employees(params?: any) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/empresausuariosvinculo`,
      {
        params: removePropertyEmpty(params)
      }
    )
    return httpResponse
  }

  async historic(id: string) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/historico?empresaId=${id}`
    )
    return httpResponse
  }
}

export const companyService = new CompanyService()
